import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { MasonryOptions } from './masonry.models';

export function fromResize(el: Element): Observable<void> {
  return new Observable(observer => {
    const ro = new ResizeObserver(() => observer.next());
    ro.observe(el);
    return () => ro.disconnect();
  });
}

export interface ItemPosition {
  x: string;
  y: string;
  originLeft: boolean;
}

export interface MasonryItem {
  comparePosition(other: MasonryItem): number;
  dimensions(): { width: number; height: number };
  applyPosition(pos: ItemPosition): void;
  ready$(): Observable<void>;
  resize$(): Observable<void>;
  element(): Element;
}

export interface MasonryContainer {
  options(): MasonryOptions;
  register(item: MasonryItem): void;
  unregister(item: MasonryItem): void;
}

export const APP_MASONRY = new InjectionToken<MasonryContainer>('AppMasonry');
